<p-select
  placeholder="Select"
  [disabled]="productNames.length === 1"
  appendTo="body"
  [options]="productNames"
  [(ngModel)]="selectedProduct"
  (onChange)="setActiveProduct($event.value)"
/>
